import { useCallback } from 'react';

type UseReviewsPagePaginationTransportArgs = {
    setReviewsOnPageState: (value: number) => void;
};

type ReviewsPagePaginationTransport = {
    setReviewsOnPage: (count: number) => Promise<void>;
};

export const useReviewsPagePaginationTransport = ({
    setReviewsOnPageState,
}: UseReviewsPagePaginationTransportArgs): ReviewsPagePaginationTransport => {
    const setReviewsOnPage = useCallback(
        async (count: number) => {
            setReviewsOnPageState(count);
        },
        [setReviewsOnPageState],
    );

    return {
        setReviewsOnPage,
    };
};
